import { formatLabel, optionsHorizontalBar } from "./utils"

const cd_direct_recovery_topic = {
  figureNumber: "2.4",
  title: "Topic",
  subTitle: "FY 2022 (percentage share of total)",
  source: "Sources: IMF, Capacity Development Management and Administration Program; and IMF staff calculations.",
  data: {
    labels: [
      formatLabel("Public finances", 30),
      formatLabel("Monetary and fincial systems", 30),
      formatLabel("Statistics", 30),
      formatLabel("Macroeconimc frameworks", 30),
      formatLabel("Legal frameworks", 30),
      formatLabel("Other", 30),
    ],
    datasets: [
      {
        label: "",
        data: [52.9, 18.4, 12.0, 11.9, 3.9, 0.9],
        backgroundColor: "#575C5C",
      },
    ],
  },
  options: optionsHorizontalBar,
}

export default cd_direct_recovery_topic;